import React from 'react';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { ArrowBack } from '@mui/icons-material';
import PropTypes from 'prop-types';
import { useTitle } from 'utils/hooks/useTitle';
import { IconButton } from '@totalsoft/rocket-ui';
import { Tooltip } from '@mui/material';

const ReportHeader = ({ t, onCloseClick, reportName }) => {
  useTitle(t('Reports.ReportTitle') + ' ' + reportName);

  return (
    <>
      <div>
        {t('Reports.ReportTitle')} <i>{reportName}</i>
      </div>
      <div>
        <Tooltip title={t('OfferAction.BackToList')}>
          <IconButton onClick={onCloseClick} tooltip={t('OfferAction.BackToList')}>
            <ArrowBack />
          </IconButton>
        </Tooltip>
      </div>
    </>
  );
};

ReportHeader.propTypes = {
  t: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  reportName: PropTypes.string.isRequired
};

export default compose(withTranslation())(ReportHeader);
